import * as React from "react"
import { GridSeeker, ImgS, LinkSeeker } from "ui-seeker/core"

import { useAlerts } from 'app/layout'
import { IMAGE } from 'app/@common/constants'
import { TableLoading } from "app/components/loading"


export default function Alerts() {

    const { isLoadingTable, alerts } = useAlerts()

    if (isLoadingTable) return <TableLoading />

    return <GridSeeker container>
        {Array.isArray(alerts) && alerts.length ? alerts.filter(f => f.enabled).map((alert, id) => {
            return <GridSeeker className="block-alerts" container item key={id}>
                <LinkSeeker href={`/notifications?alert=${alert.id_alert}&daysRange=${alert.days_range}`} wrapperClassName="fav-searches alert-shadow">
                    <GridSeeker container key={alert.id_alert} size={12} className="py-8 px-4 medium-bold-text">
                        <GridSeeker size={10} style={{ color: '#313131', textAlign: 'left' }}>
                            <p className='dashTitle line-alert'>
                                {alert.name}
                            </p>
                        </GridSeeker>
                        <GridSeeker size={2} style={{ color: '#313131', textAlign: 'left', display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <p className='dashTitle line-alert'>
                                <ImgS src={`${IMAGE.ASSETS}/right-angle.svg`} alt="Arrow icon" style={{ width: '20px', marginTop: '-2px', float: 'right' }} />
                            </p>
                        </GridSeeker>
                    </GridSeeker>
                </LinkSeeker>
                <hr className="alert-line-separator" />
            </GridSeeker>
        }) : <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ImgS className="image-no-data-bounce" style={{ height: '200px', opacity: 0.5, rowGap: '15px' }} src={`${IMAGE.ASSETS}/no-data-laptop.svg`} alt="No data available" />
            </div>
            <div className="text-no-results">No alerts found</div>
        </>}
    </GridSeeker>
}